const DRAFT_DOCUMENT_REPORT = '/draft-document/report'
const DOCUMENT_REPORT = '/document/report'
const DOCUMENT_TYPE_ROUTES = '/final-document-type/list'

export {
  DRAFT_DOCUMENT_REPORT,
  DOCUMENT_REPORT,
  DOCUMENT_TYPE_ROUTES
}
